import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { homeImgUrl, imgUrl } from "@/common/domain"
import { Lazyload, Toast } from 'vant';
import { sendGet, sendPost } from './common/sendAjax';
import Loading from "@/components/Loading.vue"
import minxin from "@/common/mixin";

Vue.config.productionTip = false
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.prototype.$toast = Toast;
Vue.prototype.$imgUrl = imgUrl;
Vue.prototype.$homeImgUrl = homeImgUrl;
Vue.prototype.$sendGet = sendGet;
Vue.prototype.$sendPost = sendPost;

Vue.component("loading", Loading)
Vue.mixin(minxin);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
